import React from "react";
import SideBanner from "components/layout/SideBanner";
import { PAGE_HEADER, STEPPERS } from "features/troca-titularidade/constants";
import { useTrocaTitularidadeTab } from "features/troca-titularidade/hooks/useTrocaTitularidadeTab";

import TrocaTitularidadeAccordion from "./TrocaTitularidadeAccordion";
import { Body, Container, Content } from "./TrocaTitularidadePage.styles";

const TrocaTitularidadePage = (): JSX.Element => {
  const defaultActiveKey = useTrocaTitularidadeTab();

  return (
    <Container>
      <SideBanner activated={1} header={PAGE_HEADER} steppers={STEPPERS} />
      <Content>
        <Body>
          <TrocaTitularidadeAccordion
            header={PAGE_HEADER}
            defaultActiveKey={defaultActiveKey}
          />
        </Body>
      </Content>
    </Container>
  );
};

export default TrocaTitularidadePage;
